import type { NavigationAdapter } from '@vestolio/app'

/**
 * Web navigation adapter using a shared navigate function.
 * The React Router navigate function is injected at app startup
 * via setNavigateFunction() so we can navigate without full page reloads.
 */

let _navigate: ((path: string) => void) | null = null

/**
 * Called once from App.tsx to inject the React Router navigate function.
 */
export function setNavigateFunction(fn: (path: string) => void) {
  _navigate = fn
}

export const webNavigation: NavigationAdapter = {
  navigate(route: string): void {
    if (_navigate) {
      _navigate(route)
    } else {
      // Fallback only during initial mount before React Router is ready
      window.location.href = route
    }
  },
}